
export default [
    {
        path: '/matter/form/:matter_id',
        name: 'MatterProgramView',
        component: () =>
            import("@/components/teaching/MatterProgram/MatterProgramView"),
    },
    {
        path: '/instructional/form/:matter_id',
        name: 'InstructionalView',
        component: () =>
            import("@/components/teaching/Instructional/InstructionalView"),
    },
    {
        // E52 · El mismo diseño, abierto desde la Asignatura base: no hay Perfil de Egreso
        // y el parámetro es el id de la Asignatura base, no el de la del Perfil.
        path: '/instructional/matter/:matter_id',
        name: 'InstructionalMatterView',
        component: () =>
            import("@/components/teaching/Instructional/InstructionalMatterView"),
    },
    {
        path: '/instructional-matrix/:matter_id',
        name: 'InstructionalMatrixView',
        component: () =>
            import("@/components/teaching/Instructional/InstructionalMatrixView"),
    },
    {
        // El documento del diseño de la Asignatura base. Es la misma vista: lo único que
        // cambia es de qué nivel pide el documento, y eso lo decide el nombre de la ruta.
        path: '/instructional-matrix/matter/:matter_id',
        name: 'InstructionalMatrixMatterView',
        component: () =>
            import("@/components/teaching/Instructional/InstructionalMatrixView"),
    },
    {
        path: '/instructional-method',
        name: 'InstructionalMethodView',
        component: () =>
            import("@/components/teaching/Instructional/InstructionalMethod/InstructionalMethodView"),
    },
    {
        path: '/planification/form/:matter_id/',
        name: 'PlanificationView',
        component: () =>
            import("@/components/teaching/Planification/PlanificationView"),
    },
    {
        path: '/section/form/',
        name: 'SectionView',
        component: () =>
            import("@/components/teaching/Section/SectionView"),
    },
    // Deprecada: tabla de evaluaciones v1. Se administran en ManageEvaluationsView (/manage-evaluations/)
    // {
    //     path: '/user_evaluation/:matter_id',
    //     name: 'EvaluationTableView',
    //     component: () =>
    //         import("@/components/teaching/Evaluation/EvaluationTableView"),
    // },
    {
        path: '/learning-suitcase/:egress_profile_matter_id',
        name: 'LearningSuitcaseView',
        component: () =>
            import("@/components/teaching/MatterProgram/LearningSuitcase/LearningSuitcaseView"),
    },
    {
        path: '/learning-suitcase-student/:egress_profile_matter_id',
        name: 'LearningSuitcaseStudentView',
        component: () =>
            import("@/components/teaching/MatterProgram/LearningSuitcase/LearningSuitcaseStudentView"),
    },
    {
        path: '/learning-suitcase-teacher/:egress_profile_matter_id',
        name: 'LearningSuitcaseTeacherView',
        component: () =>
            import("@/components/teaching/MatterProgram/LearningSuitcase/LearningSuitcaseTeacherView"),
    },
    {
        path: '/learning-experience/:egress_profile_matter_id',
        name: 'LearningExperiencesView',
        component: () =>
            import("@/components/teaching/MatterProgram/LearningSuitcase/LearningExperiencesView"),
    },
    {
        path: '/learning-evaluation/:egress_profile_matter_id',
        name: 'LearningEvaluationView',
        component: () =>
            import("@/components/teaching/MatterProgram/LearningSuitcase/LearningEvaluationView"),
    },
    {
        path: '/matter-description/:egress_profile_matter_id',
        name: 'LearningMatterDescription',
        component: () =>
            import("@/components/teaching/MatterProgram/LearningSuitcase/LearningMatterDescription"),
    },
    {
        path: '/old-matter/form/:matter_id',
        name: 'OldMatterProgramView',
        component: () =>
            import("@/components/teaching/MatterProgram/OldMatterProgramView"),
    },
    {
        path: '/matter-category/',
        name: 'MatterCategoryView',
        component: () =>
            import("@/components/teaching/CurricularResources/MatterCategory/MatterCategoryView"),
    },
];
